import { useContext } from "react";

import CommonPropsContext from "../common";

const useCommonContext = () => {
  return useContext(CommonPropsContext);
};

export default useCommonContext;
